import axiosClient from "@/utils/axios-client";
import { BuyerResponse } from "@/shared/api/buyer/types";
import { buyerUrl } from "@/shared/api/buyer/url";

// 조회 훅과 무효화하는 쪽이 같은 키를 쓰도록 한 곳에서 만든다.
export const BUYER_QUERY_KEY = (buyerId: number | undefined) => [
  "buyer",
  buyerId,
];

export const buyerQueryApi = {
  // 바이어 단건 조회 — 바이어 본인 토큰으로도 조회할 수 있다.
  getBuyer: async (buyerId: number) => {
    const { data } = await axiosClient.get<BuyerResponse>(
      buyerUrl.root(buyerId)
    );
    return data;
  },
};
